export const headerProducts = () => {
    try {
        const btn = document.querySelector('#products-btn');
        const productsMenu = document.querySelector('.products-header');
        const productsWrapper = document.querySelector('.products-header--wrapper');
        const headerItems = document.getElementsByClassName('header__item');
        const header = document.querySelector('.header');
        
        btn.addEventListener('mouseenter', function () {
        
            productsMenu.classList.add('active');
            header.classList.add('header_bg');
        });
        
/*         btn.addEventListener('mouseleave', function () {
            console.log('remove');
            productsMenu.classList.remove('active');
        }); */
        
/*         productsWrapper.addEventListener('mouseenter', function () {
            console.log('add');
            productsMenu.classList.add('active');
        }); */
        
        productsWrapper.addEventListener('mouseleave', function () {
            productsMenu.classList.remove('active');
            header.classList.remove('header_bg');
        });

        for (let i = 1; i < headerItems.length; i++) {
            headerItems[i].addEventListener('mouseenter', function () {
                productsMenu.classList.remove('active'); 
                header.classList.remove('header_bg');
            });
        }

        
    } catch (e) { }
} 
